import React, { useContext } from 'react';
import PropTypes from 'prop-types';
const { shape, func } = PropTypes;

import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import {
  formatDistance,
  getSellableQuantityNearbyStore,
  getNearbyStoreInStock,
  productShape,
  formatSellableQuantity
} from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';
import { InStockIcon } from '../../helpers/icon-utils';
import { isFunction } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';
import { PodMessage } from '../PodMessage';

export const InStockNearby = ({
  product,
  onCheckNearbyStoresClick,
  customRender,
  isNewFulfillmentPodMessagingEnabled,
  isNarrowPod
}) => {
  const { channel } = useContext(ExperienceContext);
  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');
  const nearbyStore = getNearbyStoreInStock(product);

  const emptyComponent = () => {
    if (isFunction(customRender)) {
      return customRender({ pickUpTemplate: PICKUP_TEMPLATES.EMPTY_STORE_MESSAGE,
        isEmptyComponent: true,
        icon: null,
        value: {} });
    }
    return (<div className="sui-flex" />);
  };

  if (!(product && nearbyStore)) {
    return emptyComponent();
  }

  const { storeName, distance } = nearbyStore;

  if (!(distance && storeName)) {
    return emptyComponent();
  }

  const sellableQuantity = getSellableQuantityNearbyStore(product);
  if (!sellableQuantity) {
    return emptyComponent();
  }

  const formattedQty = formatSellableQuantity(sellableQuantity);

  const storeNameLink = (
    <CheckNearByStore
      product={product}
      onCheckNearbyStoresClick={onCheckNearbyStoresClick}
      nearbyStoreName={storeName}
    />
  );

  if (isFunction(customRender)) {
    return customRender(
      { pickUpTemplate: PICKUP_TEMPLATES.IN_STOCK_NEARBY,
        icon: InStockIcon,
        values:
        { formattedQty, storeName, storeNameLink, distance: formatDistance(distance) } });
  }

  const nearByMessagingQty = `${formattedQty}${!isNewFulfillmentPodMessagingEnabled ? ' nearby' : ''}`;
  const distanceDisplay = !isNewFulfillmentPodMessagingEnabled || enablePLPFasterDeliveryOption
    ? ` (${formatDistance(distance)} mi)` : '';
  const inStockMessageText = `${isNewFulfillmentPodMessagingEnabled ? ' in stock' : ''} at `;

  return (
    <PodMessage
      messageIcon={InStockIcon}
      messageType={`Pickup${isNewFulfillmentPodMessagingEnabled ? ' Nearby' : ''}`}
      isStoreNameAtEnd
      isNewFulfillmentPodMessagingEnabled={isNewFulfillmentPodMessagingEnabled}
      nearbyStore={nearbyStore}
      distance={distance}
      isNarrowPod={isNarrowPod}
    >
      <>
        <span className="sui-text-success">{nearByMessagingQty}</span>
        <span className="sui-text-primary">{!enablePLPFasterDeliveryOption ? distanceDisplay : ''}
          {inStockMessageText}
        </span>
        {storeNameLink}
        <span className="sui-text-primary">{enablePLPFasterDeliveryOption ? distanceDisplay : ''}</span>
      </>
    </PodMessage>
  );
};

InStockNearby.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
  customRender: func,
  isNewFulfillmentPodMessagingEnabled: PropTypes.bool,
  isNarrowPod: PropTypes.bool
};

InStockNearby.defaultProps = {
  onCheckNearbyStoresClick: () => {},
  customRender: null,
  isNewFulfillmentPodMessagingEnabled: false,
  isNarrowPod: false
};
